import compose from '../../lib/compose'
import statefulValue from '../../lib/decorators/statefulValue'
import statefulFocus from '../../lib/decorators/statefulFocus'
import Checkbox from '../../Switch/Checkbox'

const UncontrolledCheckbox = compose(statefulFocus, statefulValue)(Checkbox)

UncontrolledCheckbox.displayName = 'UncontrolledSwitch.Checkbox'

export default UncontrolledCheckbox



// WEBPACK FOOTER //
// ./~/@klarna/ui/uncontrolled/Switch/Checkbox.jsx